import axios from "axios";

const postAppointmentSymptom = async (baseUrl, token, doctorId, appointmentId, symptom) => {

    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };

    var bodyFormData = new FormData();
    bodyFormData.append('symptom', symptom);

    let putResponse = null

    await axios.post(baseUrl + "/doctor/" + doctorId + "/appointment/" + appointmentId + "/symptom", bodyFormData, config)
        .then((res) => {
            putResponse = {
                status: res.data.status,
                data: res.data
            }
        }).catch((error) => {
            if (error.response !== undefined) {
                putResponse = {
                    status: error.response.status,
                    data:  error.response.status
                }
            }
        });
    return putResponse
} 

export default postAppointmentSymptom;